import React, { useEffect, useState } from "react";

const ColorPalette = ({ syncColor, defaultColor }) => {
	const presetColorCode = [
		"#3572C2",
		"#3C499A",
		"#2F9529",
		"#F1AF54",
		"#8D1B20",
		"#000000",
		"#5CABE2",
		"#663E99",
		"#96CC63",
		"#FFFC6F",
		"#E73332",
		"#FFFFFF"
	];

	const [selectedColor, setSelectedColor] = useState("");

	useEffect(() => {
		setSelectedColor(defaultColor);
	}, []);

	const handleColorClick = (color) => {
		setSelectedColor(color);
		syncColor(color);
	};

	return (
		<div style={{ display: "flex", flexWrap: "wrap" }}>
			{presetColorCode.map((color, index) => (
				<div
					key={index}
					style={{
						width: 38,
						height: 38,
						display: "flex",
						alignItems: "center",
						justifyContent: "center"
					}}
				>
					<div
						id="selected-color"
						key={index}
						style={{
							...(color === selectedColor && {
								border: "2.5px solid #FFFFFF"
							}),
							width: "72.5%",
							height: "72.5%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center"
						}}
					>
						<div
							className="color"
							style={{
								width: 18,
								height: 18,
								backgroundColor: color,
								cursor: "pointer",
								margin: 3
							}}
							onClick={() => handleColorClick(color)} data-testid="orion-components-shared-components-shape-editor-components-shared-color-picker-color-palette-div"
						/>
					</div>
				</div>
			))}
		</div>
	);
};

export default ColorPalette;
